import gql from 'graphql-tag'

import { ISchool, SchoolFieldsFragment } from '../school'

export interface ILead {
  id: number
  schoolId: number
  isBookmarked: boolean
  school: ISchool
}

export const LeadFieldsFragment = gql`
  fragment LeadFields on Lead {
    id
    schoolId
    isBookmarked
    school {
      ...SchoolFields
    }
  }

  ${SchoolFieldsFragment}
`
